import React from "react";

const IconPlaylist = ({ className }) => {
  return (
    <svg
      width={22}
      height={22}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.5833 4.35419H14.6666V2.98835C14.6666 2.22752 14.0433 1.60419 13.2825 1.60419H8.71748C7.95665 1.60419 7.33331 2.22752 7.33331 2.98835V4.35419H6.41665C5.40831 4.35419 4.58331 5.17919 4.58331 6.18752V6.30669C4.87665 6.22419 5.17915 6.18752 5.49998 6.18752H16.5C16.8208 6.18752 17.1233 6.22419 17.4166 6.30669V6.18752C17.4166 5.17919 16.5916 4.35419 15.5833 4.35419Z"
        fill="#EFEEE0"
        // fillOpacity="0.25"
      />
      <path
        d="M12.7691 15.5192C12.4758 15.5192 12.2466 15.7575 12.2466 16.0417C12.2466 16.3258 12.485 16.5642 12.7691 16.5642C13.0533 16.5642 13.2916 16.3258 13.2916 16.0417C13.2916 15.7575 13.0533 15.5192 12.7691 15.5192Z"
        fill="#EFEEE0"
        // fillOpacity="0.25"
      />
      <path
        d="M8.31419 16.3258C8.02085 16.3258 7.79169 16.5641 7.79169 16.8483C7.79169 17.1325 8.03002 17.3708 8.31419 17.3708C8.59835 17.3708 8.83669 17.1325 8.83669 16.8483C8.83669 16.5641 8.60752 16.3258 8.31419 16.3258Z"
        fill="#EFEEE0"
        // fillOpacity="0.25"
      />
      <path
        d="M17.4166 7.68167C17.1233 7.59917 16.8208 7.5625 16.5 7.5625H5.49998C5.17915 7.5625 4.87665 7.59917 4.58331 7.68167C3.00665 8.09417 1.83331 9.53333 1.83331 11.2292V16.7292C1.83331 18.7458 3.48331 20.3958 5.49998 20.3958H16.5C18.5166 20.3958 20.1666 18.7458 20.1666 16.7292V11.2292C20.1666 9.53333 18.9933 8.09417 17.4166 7.68167ZM14.6666 12.1733V16.0417C14.6666 17.0867 13.8141 17.9392 12.7691 17.9392C11.7241 17.9392 10.8716 17.0867 10.8716 16.0417C10.8716 14.9967 11.7241 14.1442 12.7691 14.1442C12.9525 14.1442 13.1266 14.1808 13.2916 14.2267V13.0717L10.2208 13.9058V16.8483C10.2208 16.8575 10.2208 16.8667 10.2116 16.8758C10.2025 17.9117 9.34998 18.755 8.31415 18.755C7.26915 18.755 6.41665 17.9025 6.41665 16.8483C6.41665 15.7942 7.26915 14.9508 8.31415 14.9508C8.49748 14.9508 8.67165 14.9875 8.84581 15.0333V13.3833V11.9625C8.84581 11.1742 9.34081 10.5325 10.0925 10.3308L12.5216 9.66167C13.3008 9.45083 13.7958 9.6525 14.0708 9.86333C14.3458 10.0742 14.6666 10.4867 14.6666 11.3025V12.1733Z"
        fill="#EFEEE0"
        // fillOpacity="0.25"
      />
    </svg>
  );
};

export default IconPlaylist;
